
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05HdGrid extends Serenity.EntityGrid<Adv05HdRow, any> {
        protected getColumnsKey() { return Adv05HdColumns.columnsKey; }
        protected getDialogType() { return Adv05HdDialog; }
        protected getIdProperty() { return Adv05HdRow.idProperty; }
        protected getInsertPermission() { return Adv05HdRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05HdRow.localTextPrefix; }
        protected getService() { return Adv05HdService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.splice(1, 0, {
                id: 'Print PDF',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-PDF" title="PDF">' +
                        '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            // if (e.isDefaultPrevented())
            //     return;

            var item = this.itemAt(row);
            var target = $(e.target);


            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('print-PDF')) {
                    this.view.getRows()
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);

                    let request: Adv05HdPrintData
                    if (fg != null) {
                        let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == userId.ShopId)
                        request = {
                            PmId: item.PmId,
                            Skip: 0,
                            Take: 0,
                            BizName: s.ShopRegName,
                            BizAddressLine1: s.ShopRegAddressLine1,
                            BizAddressLine2: s.ShopRegAddressLine2,
                            BizAddressLine3: s.ShopRegAddressLine3,
                            TaxId: s.ShopTaxId
                        } as Adv05HdPrintData
                    } else {
                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                        request = {
                            PmId: item.PmId,
                            Skip: 0,
                            Take: 0,
                            BizName: q.BizName,
                            BizAddressLine1: q.TaxInvAddrLine1,
                            BizAddressLine2: q.TaxInvAddrLine2,
                            BizAddressLine3: q.TaxInvAddrLine3,
                            TaxId: q.BizName
                        } as Adv05HdPrintData
                    }





                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })

                        ;
                }
            }
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Adv05HdService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected getQuickFilters() {
            let filters = super.getQuickFilters();
            
            filters.push({
                field: 'EndPromoDate',
                type: Serenity.DateEditor,
                title: 'กำหนดวันที่แสดงโปร',
                handler: h => {
                    if (h.active && h.value) {
                        h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                            [['EndPromoDate'], '>=', h.value],
                            [['StartPromoDate'], '<=', h.value]
                        );
                    }
                },
                init: w => {
                    (w as Serenity.DateEditor).valueAsDate = new Date();
                }
            });
    
            return filters;
        }
    }
}